import { Service, signal } from '@angular/core';

@Service()
export class WorkerBusy {
  private readonly _isBusy = signal(false);

  public readonly isBusy = this._isBusy.asReadonly();

  updateBusyState(busyState: boolean) {
    this._isBusy.set(busyState);
  }
}
